import * as React from 'react';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {formEncodedApi} from 'nutshell-core/api';
import type {CoreEntityType} from 'nutshell-core/types';

import {Button} from 'shells/button/button';
import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

import {AddToAudiencePopover} from '../../core/audiences/add-to-audience-popover';

import {AddToAudienceOnboardingModal} from './add-to-audience-onboarding-modal';

type OwnProps = {
    entityType: CoreEntityType;
    selectedCount: number;
    onSubmit: (audience: ListOptionWithCount, onlyPrimaryContact: boolean) => Promise<any>;
    isDisabled?: boolean;
    currentAudienceId?: string;
};

type Props = OwnProps & ContextRouter;

export function AddToAudienceButtonRouted(props: Props) {
    const audienceButton = React.useRef(null);
    const [shouldShowOnboardingModal, setShouldShowOnboardingModal] = React.useState<boolean>(
        NutClientConfig.shouldShowAddToAudienceOnboardingModal
    );
    const [isShowingPopover, setIsShowingPopover] = React.useState<boolean>(false);
    const [shouldWiggle, setShouldWiggle] = React.useState<boolean>(false);
    const [audience, setAudience] = React.useState<
        | {
              name: string;
              htmlUrlPath: string;
          }
        | null
        | undefined
    >(null);

    React.useEffect(() => {
        if (
            NutClientConfig.onboardingAudience &&
            NutClientConfig.onboardingAudience.audienceName &&
            NutClientConfig.onboardingAudience.audienceHtmlUrlPath
        ) {
            // Need a slight delay or its a bit jarring
            setTimeout(() => {
                setAudience({
                    name: NutClientConfig.onboardingAudience.audienceName,
                    htmlUrlPath: NutClientConfig.onboardingAudience.audienceHtmlUrlPath,
                });

                // Clear this jank local state
                delete NutClientConfig.onboardingAudience;

                // Wiggle the button for flair
                setShouldWiggle(true);
            }, 1000);
        }
    }, []);

    const handleClose = () => {
        setShouldShowOnboardingModal(false);
        formEncodedApi
            .post('/my-account/save-user-setting.json', {
                setting: 'has_dismissed_add_to_audience_modal',
                value: 1,
            })
            .then(() => {
                NutClientConfig.shouldShowAddToAudienceOnboardingModal = false;
            });
    };

    return (
        <React.Fragment>
            <Button
                id='add-to-audience-button'
                size='big'
                getButtonRef={audienceButton}
                disabled={props.isDisabled}
                className='popover-opener-audience'
                wiggle={shouldWiggle}
                onClick={() => setIsShowingPopover(true)}
            >
                {props.currentAudienceId ? 'Add to another audience' : 'Add to audience'}
            </Button>
            {isShowingPopover ? (
                <AddToAudiencePopover
                    entityType={props.entityType}
                    anchor={audienceButton.current}
                    onCancel={() => setIsShowingPopover(false)}
                    onSubmit={props.onSubmit}
                    selectedCount={props.selectedCount}
                    excludedAudienceIds={props.currentAudienceId ? [props.currentAudienceId] : []}
                />
            ) : undefined}
            {shouldShowOnboardingModal && audience ? (
                <AddToAudienceOnboardingModal
                    entityType={props.entityType}
                    audience={audience}
                    onClose={handleClose}
                />
            ) : undefined}
        </React.Fragment>
    );
}

// @ts-expect-error
export const AddToAudienceButton = withRouter<OwnProps>(AddToAudienceButtonRouted);
